import React, { memo } from "react";

import { isEmpty } from "@swiggy-private/js-utils";
import { ICartSavingsFooterDetails } from "@swiggy-private/cart-types";
import { CART_SAVINGS_FOOTER_STRIP_TEST_IDS } from "@swiggy-private/cart-test-ids";

import { StripContainer, StripText } from "./CartSavingsFooterStrip.style";

export interface CartSavingsFooterStripProps {
    details: ICartSavingsFooterDetails;
}

const CartSavingsFooterStrip = ({ details }: CartSavingsFooterStripProps) => {
    if (isEmpty(details.savingsText)) {
        return null;
    }

    return (
        <StripContainer
            $backgroundColor={details.backgroundColor}
            data-testid={CART_SAVINGS_FOOTER_STRIP_TEST_IDS.CONTAINER}
        >
            <StripText
                variant="V2.overline.neutral.bold"
                color={details.textColor}
                data-testid={CART_SAVINGS_FOOTER_STRIP_TEST_IDS.TEXT}
            >
                {details.savingsText}
            </StripText>
        </StripContainer>
    );
};

export default memo(CartSavingsFooterStrip);
